import MatchMediaWatcher from '@/utils/Match-media';
import Vue from 'vue';

export const DEVICE_TYPES = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};

export default class Adaptive {
  constructor(defaultDevice = DEVICE_TYPES.mobile) {
    this.data = Vue.observable({
      isMobile: defaultDevice === DEVICE_TYPES.mobile,
      isTablet: defaultDevice === DEVICE_TYPES.tablet,
      isDesktop: defaultDevice === DEVICE_TYPES.desktop,
    });

    this.watcherMobile = null;
    this.watcherTablet = null;
    this.watcherDesktop = null;
  }

  get isMobile() {
    return this.data.isMobile;
  }

  get isTablet() {
    return this.data.isTablet;
  }

  get isDesktop() {
    return this.data.isDesktop;
  }

  initMatchMedia() {
    this.watcherMobile = MatchMediaWatcher.getWatcher();
    this.watcherTablet = MatchMediaWatcher.getWatcher();
    this.watcherDesktop = MatchMediaWatcher.getWatcher();

    this.watcherMobile.addHandler('(max-width: 767px)', (isMatched) => {
      this.data.isMobile = isMatched;
    });
    this.watcherTablet.addHandler('(min-width: 768px) and (max-width: 1079px)', (isMatched) => {
      this.data.isTablet = isMatched;
    });
    this.watcherDesktop.addHandler('(min-width: 1080px)', (isMatched) => {
      this.data.isDesktop = isMatched;
    });

    this.watcherMobile.execute();
    this.watcherTablet.execute();
    this.watcherDesktop.execute();
  }
}
